/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

const getMetadata = (state) => state.metadata;

const sortByName = (a, b) => a.name.localeCompare(b.name);

export const getStates = createSelector(getMetadata, (metadata) => {
  const { states } = metadata;
  if (!isEmpty(states)) {
    return [...states].sort(sortByName);
  }
  return [];
});

export const getCountries = createSelector(getMetadata, (metadata) => {
  const { countries } = metadata;
  if (!isEmpty(countries)) {
    return [...countries].sort(sortByName);
  }
  return [];
});

export const getMilitaryStates = createSelector(getMetadata, (metadata) => {
  const { militaryStates } = metadata;
  if (!isEmpty(militaryStates)) {
    return [...militaryStates].sort(sortByName);
  }
  return [];
});

export const getMilitaryCities = createSelector(getMetadata, (metadata) => {
  const { militaryCities } = metadata;
  if (!isEmpty(militaryCities)) {
    return [...militaryCities].sort(sortByName);
  }
  return [];
});
